import { useNavigate } from "react-router-dom";

import ArrowUpRight from "@/assets/icons/arrow-up-right.svg?react";

import { Button } from "@/components/Button";

import { APP_ROUTES } from "@/routes/constants";

import styles from "./styles";

import promotion from "@/assets/icons/networks/evm.svg";
import { useTranslation } from "react-i18next";
import firstCard from "@/assets/images/first-card-image.png";
import secondCard from "@/assets/images/second-card-image.png";
import thirdCard from "@/assets/images/third-card-image.png";
import { Network } from "@/interfaces/network";
import { useStore } from "@/hooks/store";
import { logger } from "@/services/config/mixpanel";
import { MIXPANEL_EVENTS } from "@/interfaces/mixpanel";

export const Promotion: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { switchNetwork } = useStore((state) => ({
    networks: Object.values(state.user.networksData),
    currentNetwork: state.network,
    switchNetwork: state.switchNetwork,
  }));

  return (
    <styles.Container>
      <Button
        name="Back"
        iconLeft={<ArrowUpRight />}
        type="black"
        handler={() => {
          navigate(APP_ROUTES.HOME);
        }}
      />
      <styles.MainContainer>
        <img src={promotion} />
        <styles.Title>{t("Promotion.Title")}</styles.Title>
        <styles.CardContainer>
          <styles.CardNumber>01</styles.CardNumber>
          <styles.CardTitle>{t("Promotion.FirstCardTitle")}</styles.CardTitle>
          <styles.CardDescription>{t("Promotion.FirstCardDescription")}</styles.CardDescription>
          <img src={firstCard} />
        </styles.CardContainer>
        <styles.CardContainer>
          <styles.CardNumber>02</styles.CardNumber>
          <styles.CardTitle>{t("Promotion.SecondCardTitle")}</styles.CardTitle>
          <styles.CardDescription>{t("Promotion.SecondCardDescription")}</styles.CardDescription>
          <img src={secondCard} />
        </styles.CardContainer>
        <styles.CardContainer>
          <styles.CardNumber>03</styles.CardNumber>
          <styles.CardTitle>{t("Promotion.ThirdCardTitle")}</styles.CardTitle>
          <styles.CardDescription>{t("Promotion.ThirdCardDescription")}</styles.CardDescription>
          <img src={thirdCard} />
        </styles.CardContainer>
        <styles.ButtonContainer>
          <Button
            name="Mint"
            type="secondary"
            handler={() => {
              logger.trackEvent(MIXPANEL_EVENTS.USER_CLICK_MINT_SCORE_NETWORK);
              switchNetwork(Network.ETHEREUM);
              navigate(APP_ROUTES.HOME);
            }}
          />
        </styles.ButtonContainer>
      </styles.MainContainer>
    </styles.Container>
  );
};
